import React from 'react';
import styled from 'styled-components';
import { InteractiveStyle } from './layout';

export const PlusOrPlusSign = (props) => {
  let { height, width, open } = props;
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8 8C8 11.315 8 14 8 14C8 14 8 11.315 8 8ZM8 8C8 4.685 8 2 8 2C8 2 8 4.685 8 8Z"
        stroke={open ? 'black' : 'transparent'}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 8C4.685 8 2 8 2 8C2 8 4.685 8 8 8ZM8 8C11.315 8 14 8 14 8C14 8 11.315 8 8 8Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const RawRightArrow = (props) => {
  let { width, height } = props;
  return (
    <svg
      width={width || 36}
      height={height || 36}
      viewBox="0 0 36 36"
      fill="none"
      {...props}
    >
      <g filter="url(#prefix__filter0_d)">
        <path
          d="M2 18C2 9.163 9.163 2 18 2s16 7.163 16 16-7.163 16-16 16S2 26.837 2 18z"
          fill="#fff"
        />
        <path
          d="M15.5 23l5-5-5-5"
          stroke="#000"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={0}
          y={0}
          width={36}
          height={36}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const RightArrow = styled(RawRightArrow)`
  ${InteractiveStyle}
`;

const RawLeftArrow = (props) => {
  let { width, height } = props;
  return (
    <svg
      width={width || 36}
      height={height || 36}
      viewBox="0 0 36 36"
      fill="none"
      {...props}
    >
      <g filter="url(#prefix__filter0_d)">
        <path
          d="M2 18C2 9.163 9.163 2 18 2s16 7.163 16 16-7.163 16-16 16S2 26.837 2 18z"
          fill="#fff"
        />
        <path
          d="M19.5 13l-5 5 5 5"
          stroke="#000"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={0}
          y={0}
          width={36}
          height={36}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const LeftArrow = styled(RawLeftArrow)`
  ${InteractiveStyle}
`;
